/** @type {(service: string) => boolean} */
export const isVHAudioStreamService = (service) => {
  if (service === 'elevenlabs_streaming') {
    return true;
  }
  return false;
};

/** @type {(playerType: 'heygen' | '3D' | 'basic') => boolean} */
const isStreamablePlayer = (playerType) => {
  return playerType === 'heygen';
};

/** @type {(service: string, playerType: 'heygen' | '3D' | 'basic') => boolean} */
export const GetShouldGenerateAudio = (service, playerType) => {
  return !isStreamablePlayer(playerType) && !isVHAudioStreamService(service);
};